import React, { FC, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Breadcrumbs, Typography, Link, Box } from '@mui/material';

interface BreadcrumbProps {
  title?: string;
  items: {
    label: string;
    active?: boolean;
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
    url?: string;
    state?: any | null; // Agregar estado opcional
  }[];
}

const Breadcrumb: FC<BreadcrumbProps> = ({ title, items }) => {
  const navigate = useNavigate(); // Inicializar el hook useNavigate

  const renderBreadcrumbItem = (item: BreadcrumbProps['items'][0], index: number) => {
    const isActive = item.active;

    if (isActive) {
      return (
        <Typography key={index} color="textPrimary" aria-current="page">
          {item.label}
        </Typography>
      );
    }

    if (item.onClick) {
      return (
        <Link
          key={index}
          href="#"
          onClick={item.onClick}
          color="inherit"
          sx={{ cursor: 'pointer', textDecoration: 'none', '&:hover': { color: 'primary.main' } }}
        >
          {item.label}
        </Link>
      );
    }

    if (item.url) {
      return (
        <Link
          key={index}
          onClick={() => navigate(item.url || '', { state: { estado: item.state } })}
          color="inherit"
          sx={{
            cursor: 'pointer',
            textDecoration: 'none',
            '&:hover': { color: 'primary.main' },
          }}
        >
          {item.label}
        </Link>
      );
    }

    return (
      <Typography key={index} color="textPrimary">
        {item.label}
      </Typography>
    );
  };

  return (
    <Box sx={{ marginBottom: '20px' }}>
      {/* Título */}
      <Typography variant="h4" gutterBottom>
        {title}
      </Typography>

      {/* Breadcrumbs */}
      <Breadcrumbs aria-label="breadcrumb">
        {items.map((item, index) => renderBreadcrumbItem(item, index))}
      </Breadcrumbs>
    </Box>
  );
};

export default Breadcrumb;